import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  { path: 'landing', loadChildren: () => import('./modules/software/landing/landing.module').then(m => m.LandingModule) },
  { path: 'security', loadChildren: () => import('./modules/software/security/security.module').then(m => m.SecurityModule) },
  { path: 'office', loadChildren: () => import('./modules/software/office/office.module').then(m => m.OfficeModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
